module.exports = "/images/Georgia.png?4974057dbb5ddfce75ac6f6ed0b553ee";